export default function isMac() {
    if (window.navigator.userAgent.indexOf("Windows") != -1) return false;
    if (window.navigator.userAgent.indexOf("Mac") != -1) return true;
    return false;
}
